import React, { useState } from 'react';
import Certificate1 from './Certificate1';
import Certificate2 from './Certificate2';
import Certificate3 from './Certificate3';
import Certificate4 from './Certificate4';
import Certificate5 from './Certificate5';
import Certificate6 from './Certificate6';
import Certificate7 from './Certificate7';

const Award_Certificate = () => {
  const [activeView, setActiveView] = useState('cert1');

  // Color scheme
  const colors = {
    primary: '#B22234',
    secondary: '#2ecc71',
    danger: '#e74c3c',
    warning: '#f39c12',
    dark: '#34495e',
    light: '#ecf0f1'
  };

  return (
    <div className="container-fluid p-4 main-content-of-page">
      <div className="row justify-content-center">
        <div className="col-12 text-center mb-4">
          <h1 className="display-4" style={{ color: colors.dark }}>Award Certificates</h1>
          <p className="lead text-muted">Select a certificate to view</p>
        </div>
      </div>

      {/* Certificate Navigation Buttons */}
      <div className="row justify-content-center mb-4">
        <div className="col-12 col-md-10 col-lg-8">
          <div className="d-flex flex-wrap justify-content-center gap-2">
            <button 
              onClick={() => setActiveView('cert1')}
              className={`btn ${activeView === 'cert1' ? 'btn-primary' : 'btn-outline-primary'} px-4 py-2`}
            >
              Certificate 1
            </button>
            <button 
              onClick={() => setActiveView('cert2')}
              className={`btn ${activeView === 'cert2' ? 'btn-primary' : 'btn-outline-primary'} px-4 py-2`}
            >
              Certificate 2
            </button>
            <button 
              onClick={() => setActiveView('cert5')}
              className={`btn ${activeView === 'cert5' ? 'btn-primary' : 'btn-outline-primary'} px-4 py-2`}
            >
              Certificate 3
            </button>
            <button 
              onClick={() => setActiveView('cert6')}
              className={`btn ${activeView === 'cert6' ? 'btn-primary' : 'btn-outline-primary'} px-4 py-2`}
            >
              Certificate 4
            </button>
            <button 
              onClick={() => setActiveView('cert7')}
              className={`btn ${activeView === 'cert7' ? 'btn-primary' : 'btn-outline-primary'} px-4 py-2`}
            >
              Certificate 5
            </button>
            <button 
              onClick={() => setActiveView('cert3')}
              className={`btn ${activeView === 'cert3' ? 'btn-primary' : 'btn-outline-primary'} px-4 py-2`}
            >
              Certificate 6
            </button>
            <button 
              onClick={() => setActiveView('cert4')}
              className={`btn ${activeView === 'cert4' ? 'btn-primary' : 'btn-outline-primary'} px-4 py-2`}
            >
              Certificate 7
            </button>
          </div>
        </div>
      </div>

      {/* Certificate Content Area */}
      <div className="row justify-content-center">
        <div className="col-12 col-md-10 col-lg-8">
          <div className="card shadow-sm border-0">
            <div className="card-body p-4" style={{ backgroundColor: colors.light }}>
              {activeView === 'cert1' && <Certificate1 />}
              {activeView === 'cert2' && <Certificate2 />}
              {activeView === 'cert5' && <Certificate5 />}
              {activeView === 'cert6' && <Certificate6 />}
              {activeView === 'cert7' && <Certificate7 />}
              {activeView === 'cert3' && <Certificate3 />}
              {activeView === 'cert4' && <Certificate4 />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Award_Certificate;